import { useEffect, useMemo, useState } from "react";
import "./style.css";
import FALLBACK_IMAGE from "@/assets/images/illustrative_image.png" 

type GalleryProps = {
  images?: (string | null | undefined)[];
  url: string;                            
};


const Gallery = ({ images, url }: GalleryProps) => {
  // Normaliza e já produz URLs completas
  const normalizedImages = useMemo(() => {
    const list = Array.isArray(images)
      ? images.filter((i): i is string => typeof i === "string" && i.trim() !== "")
      : [];

    // Se não tem nada válido, usa o fallback (URL absoluta no public)
    const base = list.length === 0 ? [FALLBACK_IMAGE] : list;

    // Se a string já for absoluta (http/https/data), mantém; senão prefixa com `url`
    return base.map((img) => {
      const isAbsolute = /^https?:\/\//i.test(img) || /^data:/i.test(img) || img.startsWith("/");
      return isAbsolute ? img : `${url}${img}`;
    });
  }, [images, url]);

  const [selectedImage, setSelectedImage] = useState<string>(normalizedImages[0]);
  const [modalOpen, setModalOpen] = useState(false);

  // Sempre que a lista normalizada mudar, garante uma imagem selecionada
  useEffect(() => {
    setSelectedImage(normalizedImages[0]);
  }, [normalizedImages]);

  return (
    <div className="gallery-container">
      <div className="main-image-container">
        <img
          src={selectedImage}
          alt="Main"
          className="main-image"
          onClick={() => setModalOpen(true)}
        />
      </div>

      <div className="thumbnails-container">
        {normalizedImages.map((src, idx) => (
          <img
            key={idx}
            src={src}
            alt={`Thumbnail ${idx + 1}`}
            className="thumbnail"
            onClick={() => setSelectedImage(src)}
          />
        ))}
      </div>

      {modalOpen && (
        <div className="modal" onClick={() => setModalOpen(false)}>
          <img
            src={selectedImage}
            alt="Modal"
            className="modal-image"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </div>
  );
};

export default Gallery;
